import NodeServer from '../common/node_server';
import { IAppState } from '../reducers';
import resources from '../resources';
import config from '../services/config';
import connectServerService from '../services/connect_server_service';
const ClientOAuth2 = require('client-oauth2');

var client = new ClientOAuth2(config.auth);

export const AUTH_TOKEN_LOADING = 'AUTH/AUTH_TOKEN_LOADING';
export const AUTH_TOKEN_LOAD_SUCCESS = 'AUTH/AUTH_TOKEN_LOAD_SUCCESS';
export const AUTH_TOKEN_LOAD_FAILED = 'AUTH/AUTH_TOKEN_LOAD_FAILED';
export function getToken(username, password) {
  return (dispatch, getState) => {
    const state: IAppState = getState();

    let usernameString = `FacilityUser|${username}`;
    if (config.usage == 'cloud') {
      usernameString = `FacilityUser|${state.common.facility.id}|${username}`;
    }

    return resources.auth
      .postToken(usernameString, password)
      .then((data) => client.createToken(data))
      .then((accessToken) => {
        dispatch({ type: AUTH_TOKEN_LOAD_SUCCESS, accessToken });
        try {
          NodeServer.get().authenticate(accessToken);
        } catch (e) {
          console.log('Failed to authenticate with the node server', e);
        }
      })
      .catch((err) => {
        dispatch({ type: AUTH_TOKEN_LOAD_FAILED, error: err });
        throw err;
      });
  };
}

export const LOGOUT = 'AUTH/LOGOUT';
export function logout(storeRedirectUrl = false) {
  return (dispatch, getState) => {
    const state: IAppState = getState();
    if (state.auth.loggedIn) {
      connectServerService.close();
      try {
        NodeServer.get().disconnect();
      } catch (e) {
        console.log('Failed to unauthenticate with the node server', e);
      }
      dispatch({
        type: LOGOUT,
        redirectUrl:
          storeRedirectUrl && window.location.pathname != '/login'
            ? window.location.pathname
            : '/'
      });
    }
  };
}

export const REFRESHING_TOKEN = 'AUTH/REFRESHING_TOKEN';
export function refreshToken(tokenData) {
  return (dispatch, getState) => {
    const state = getState();

    // Add the facility ID to the headers for cloud support
    const headers = {};
    if (state.common.facility) {
      headers['X-Facility-ID'] = state.common.facility.id;
    }

    dispatch({ type: REFRESHING_TOKEN });
    let token = client.createToken(
      tokenData.accessToken,
      tokenData.refreshToken,
      tokenData.tokenType,
      tokenData.data
    );
    token.expiresIn(new Date(tokenData.expires));
    return token
      .refresh({ headers })
      .then((result) => {
        dispatch({ type: AUTH_TOKEN_LOAD_SUCCESS, accessToken: result });
        return result;
      })
      .catch((err) => dispatch({ type: AUTH_TOKEN_LOAD_FAILED, error: err }));
  };
}
